import { useContext } from 'react'
import swal from 'sweetalert2'

import { faPencil, faPlus } from '@fortawesome/pro-light-svg-icons'

import { Box, DashboardModuleListItem, ListItem } from '@domain-group/suit-theme'

import { sortArrayBy } from '@domain-group/javascript-utils'

import PageContext from '@contexts/pageContext'

import useProcessingFee from '@hooks/useProcessingFee'
import useSelector from '@hooks/useSelector'

import type { ProcessingFeeModel, ServiceModel } from '@models/types'

import type { DeleteEntity } from '@redux/modules/types'

import ProcessingFee from '../ProcessingFee'

const confirmDelete = (deleteProcessingFee: Function, deleteFn: DeleteEntity) => {
  const deleteProcessingFeePayload = {
    callbacks: {
      action: deleteFn,
    },
    toastText: 'Processing Fee Deleted',
  }

  swal.fire({
    confirmButtonColor: '#DD6B55',
    confirmButtonText: 'Yes, delete it.',
    icon: 'warning',
    showCancelButton: true,
    text: 'Are you sure?',
    title: 'Delete Processing Fee?',
  }).then(({ value }) => {
    if (value){
      deleteProcessingFee(deleteProcessingFeePayload)
    }
  })
}

type ProcessingFeeGroupProps = {
  initProcessingFee: Partial<ProcessingFeeModel>,
  isMasterAdmin: boolean,
  processingFeeGroup: {
    serviceProcessingFee: ProcessingFeeModel,
    productProcessingFees: ProcessingFeeModel[],
  },
  service: ServiceModel,
  showAddService: boolean,
}

const ProcessingFeeGroup = (props: ProcessingFeeGroupProps) => {
  const {
    initProcessingFee, isMasterAdmin, processingFeeGroup, service: { title: serviceTitle }, showAddService,
  } = props

  const { serviceProcessingFee, productProcessingFees } = processingFeeGroup

  const pageContext = useContext(PageContext)
  const { callbacks } = pageContext
  const { deleteProcessingFee } = callbacks || {}

  const hasServiceProcessingFee = !!serviceProcessingFee

  const processingFeePayload = useProcessingFee(serviceProcessingFee || initProcessingFee)
  const {
    callbacks: { createOrEditProcessingFee, deleteProcessingFee: deleteFn },
    valueText,
    processingFee: { value },
  } = processingFeePayload

  const serviceProducts = useSelector(reduxState => reduxState.entities.serviceProducts)

  const sortedProcessingFees = sortArrayBy(
    productProcessingFees,
    'asc',
    ({ billable_id }) => serviceProducts[billable_id]?.title,
  )

  return (
    <ListItem
      boxProps={{ borderBottom: '1px dashed' }}
      disableHover
      flexDirection="column"
    >
      <DashboardModuleListItem
        title={(
          <Box>
            {serviceTitle}
            <Box color="bodyFontLightColor">
                &nbsp;(Service)
            </Box>
          </Box>
        )}
      >
        {!!value && (
          // @ts-expect-error TS2339
          <DashboardModuleListItem.TertiaryText>
            {valueText}
            {/*
            // @ts-expect-error TS2339 */}
          </DashboardModuleListItem.TertiaryText>
        )}

        {isMasterAdmin && (
          // @ts-expect-error TS2339
          <DashboardModuleListItem.Actions>
            {showAddService && (
              // @ts-expect-error TS2339
              <DashboardModuleListItem.Icon
                icon={hasServiceProcessingFee ? faPencil : faPlus}
                marginRight={hasServiceProcessingFee ? 'medium' : 0}
                onClick={() => createOrEditProcessingFee()}
              />
            )}

            {hasServiceProcessingFee && (
              // @ts-expect-error TS2339
              <DashboardModuleListItem.Icon
                onClick={() => confirmDelete(deleteProcessingFee, deleteFn)}
                type="delete"
              />
            )}
            {/*
            // @ts-expect-error TS2339 */}
          </DashboardModuleListItem.Actions>
        )}
      </DashboardModuleListItem>

      {sortedProcessingFees.map(processingFee => (
        <ProcessingFee
          key={processingFee.id}
          callbacks={{
            confirmDelete: (deleteFnParam: DeleteEntity) => confirmDelete(deleteProcessingFee, deleteFnParam),
          }}
          isMasterAdmin={isMasterAdmin}
          processingFee={processingFee}
        />
      ))}
    </ListItem>
  )
}

export default ProcessingFeeGroup
